import {client} from '../helpers/api';

export async function getHomeGrades() {
  const response = await client.get('/api/grades?home=true');
  if (response.data?.status) {
    return (
      response.data?.data.map(({grade_id: id, grade_type: type}) => ({
        id,
        type,
      })) || []
    );
  }
  throw response;
}

// {
//   "grade_id": "9ab499c9-c4a9-454d-82a1-56927cfd2708",
//   "grade_type": "Form 4",
//   "grade_number": null,
//   "date_created": "2021-01-14 11:33:11",
//   "date_modified": "2021-01-14 11:33:11",
//   "status": "active",
//   "is_deleted": 0
// },
